import { Col, Form, Input, Row } from 'antd'
import CustomSpin from '../elements/CustomSpin'
import DeliveryDetails from '../elements/DeliveryDetails'
import FormSectionTitle from '../elements/FormSectionTitle'
import { defaultFormItemLayout, rules } from '../modules/FormItems'
import React from 'react'

function DeliveryAddressModalForm(props) {
  const { submitting } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form

  return (
    <CustomSpin spinning={submitting}>
      <Form>
        <FormSectionTitle title={'Details'} />
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Name'}>
              {getFieldDecorator('name', {
                rules: rules.select,
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>

        <DeliveryDetails
          doc={{}}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
            type: 'Enquiry',
          }}
        />
      </Form>
    </CustomSpin>
  )
}

export default Form.create()(DeliveryAddressModalForm)
